// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"363":"21707e14","624":"781776ce","639":"05d085f1","883":"8dac052b"}[chunkId] + ".chunk.js";
};